import React, { useState } from 'react';
import PropTypes from 'prop-types';

import InputForm from './InputForm';

import './styles.scss';

function ChannelWhatsAppSendfySettings({ sendfySettings, user, onChange }) {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <>
      <InputForm
        disabled={
          !!(user && user.selectedCompany?.claim?.name.name === 'Viewer')
        }
        id="number"
        name="number"
        label="Número"
        placeholder="5511999999999"
        value={sendfySettings.number}
        onChange={onChange}
      />

      <InputForm
        disabled={!!(user && user.selectedCompany?.claim?.name === 'Viewer')}
        id="campaign"
        name="campaign"
        type="number"
        label="Campanha"
        placeholder="1234"
        value={sendfySettings.campaign}
        onChange={onChange}
      />

      <InputForm
        disabled={!!(user && user.selectedCompany?.claim?.name === 'Viewer')}
        id="username"
        name="username"
        type="text"
        label="Usuário"
        placeholder="usuário do canal"
        value={sendfySettings.username}
        onChange={onChange}
      />

      <InputForm
        disabled={!!(user && user.selectedCompany?.claim?.name === 'Viewer')}
        id="password"
        name="password"
        type={showPassword ? 'text' : 'password'}
        label="Senha"
        placeholder="********"
        value={sendfySettings.password}
        onChange={onChange}
        toggleShowPassword={() => setShowPassword(!showPassword)}
        showPassword={showPassword}
      />
    </>
  );
}

ChannelWhatsAppSendfySettings.propTypes = {
  sendfySettings: PropTypes.shape({
    number: PropTypes.string,
    campaign: PropTypes.string,
    username: PropTypes.string,
    password: PropTypes.string,
  }).isRequired,
  user: PropTypes.shape({
    claim: PropTypes.shape({
      name: PropTypes.string,
    }),
  }).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default ChannelWhatsAppSendfySettings;
